import { render, staticRenderFns } from "./svg_icon.vue?vue&type=template&id=3e00b644&lang=html&"
import script from "./svg_icon.vue?vue&type=script&lang=js&"
export * from "./svg_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports